export enum SectionType {
    Head = 'Head',
    Body = 'Body',
    Footer = 'Footer',
}

export enum CellType {
    Head = 'Head',
    Data = 'Data',
}
